export default __webpack_public_path__ + "655f1c108a96a3b170bee4dda842ba58.jpg";